/**
 * Created by agengmaulana on 5/3/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'
import Comment_Profile_Image from '../comment_profile_image/comment_profile_image'
import Comment_Username from '../comment_username/comment_username'
import Comment_Like_Button from '../comment_like_button/comment_like_button'
import Comment_Reply_Button from '../comment_reply_button/comment_reply_button'
import Comment_Report_Abuse from '../comment_report_abuse/comment_report_abuse'
import Comment_Share from '../comment_share/comment_share'
import Comment_Form from './../comment_form/comment_form'
import Comment_Child_Row from './../comment_row/comment_child_row'
import {observer} from "mobx-react"
import {observable} from 'mobx'

@observer
export default class Comment_Row extends React.Component {


    @observable disp = false
    @observable showhide = false

    constructor(props) {
        super(props);

    }


    Open=(e)=>{

        this.props.datFunction.configKomentar.onresize()
        e.preventDefault();
        this.disp = !this.disp
    }
    openhide = (data) => {
        if(data == true){
            this.showhide = !this.showhide
            this.showhide = false
        }
        this.showhide = !this.showhide

        this.props.datFunction.anchormaster = ''
        this.props.datFunction.anchor  = ''
        this.props.datFunction.configKomentar.onresize()
    }

    closeForm=()=>{
        setTimeout(()=>{
            this.disp = false},1500)

    }

    render(){

        const {dataStore,datFunction,datastoresVerified} = this.props;

        const uaBreak = /iPhone|iPad|iPod/i.test(navigator.userAgent)?'break-all':'normal'
        let anchorhighlight = datFunction.anchor == dataStore.id ? styles.cmt_highlight : ''
        let nodes =  dataStore.child.map((person,i)=> {
            if (i < dataStore.child.length - 2 && this.showhide == false )return
                return (
                    <Comment_Child_Row dataStore={datFunction} content={person.content}
                                       image={person.author.photo}
                                       uniqueid={person.author.uniqueid}
                                       nickname={person.author.name}
                                       refer={person.authorRefer}
                                       refer_id={person.refer}
                                       status_lapor={person.reporter.length}
                                       status_like={person.liker.length}
                                       like={person.like}
                                       create_date={person.create_date}
                                       parent_id={dataStore.id}
                                       child={person.child}
                                       mod={person.mod}
                                       pilihanredaksi={person.pilihanredaksi}
                                       dispParent="false"
                                       openHide={this.openhide}
                                       isMobile={this.props.isMobile}
                                       verified_user={typeof person.author.verified_user !== 'undefined'?person.author.verified_user:false}
                                       uaBreak={uaBreak}
                                       key={person.id} id={person.id} moderasi={person.moderasi}
                                       datastoresVerified={datastoresVerified}/>

                );

        });
        const namehideshow = this.showhide ? 'Sembunyikan balasan' : dataStore.child.length - 2 +' balasan lainnya'
        const arrow = this.showhide ? 'dk_icon-angle-down' : 'dk_icon-angle-up'
        const lihatbalasan = <a href="javascript:void(0);" onClick={this.openhide} className={styles.cmt_more_komen+' '+styles.cmt_href}>{namehideshow} <i className={styles.icon+' '+arrow}></i></a>


        return(

            <div className={styles.cmt_list_dk +' '+anchorhighlight} id={'cmt'+dataStore.id} key={dataStore.id}>

                <div className={styles.cmt_dk_thread}>
                    <Comment_Profile_Image mr10="false" photo={dataStore.author.photo} nickname={dataStore.author.name}/>
                    { dataStore.pilihanredaksi == true ?
                    <div className={styles.cmt_label_pilred+' '+styles.cmt_fr}>
                        <i className={styles.icon+' dk_icon-check-square cmt_check'}></i> Komentar Pilihan
                        </div> : ''
                    }
                    <Comment_Username mb10="false" nickname={dataStore.author.name} create_date={dataStore.create_date} verified_user={typeof datastoresVerified[dataStore.author.uniqueid] !== 'undefined'?datastoresVerified[dataStore.author.uniqueid]:false}/>

                    <div className={styles.cmt_box_text+' '+styles.cmt_dk_komen} style={{wordBreak:uaBreak}}>
                        {unescape(dataStore.content)}
                        <div className={styles.cmt_dk_action} >
                            <Comment_Report_Abuse id={dataStore.id} isMobile={this.props.isMobile} status_lapor={dataStore.reporter.length} datFunction={datFunction} />

                            <Comment_Like_Button id={dataStore.id} isMobile={this.props.isMobile} parent_id="0" status_like={dataStore.liker.length} like={dataStore.like} dataStore={datFunction}/>
                            <Comment_Reply_Button toggle={this.Open} textreply={this.disp} idButton={dataStore.id}/>
                            Bagikan:    <Comment_Share content={dataStore.content} id={dataStore.id} datFunction={datFunction} />
                        </div>
                    </div>
                </div>
                <div className={styles.cmt_list_dk_sub+' '+styles.cmt_form_balas} >

                    {dataStore.child.length > 3  ? lihatbalasan : dataStore.child.length > 2 ? lihatbalasan : null}
                        {this.disp ? <Comment_Form closeForm={this.closeForm} dataStore={datFunction}
                                                   parent_id={dataStore.id} refer_id={dataStore.id} sendTo="2" />  : ''}
                </div>
                    {nodes}
            </div>
        )
    }


}


// WEBPACK FOOTER //
// ./static/src/component/comment_row/comment_row.js